
const __ENV__ = window.__CONTESTER_ENV__
export const APP_ENV = (__ENV__ && __ENV__ !== '__ENV_PLACEHOLDER__' ? __ENV__ : null) || process.env.REACT_APP_ENV || ''
export const IS_STAGING = APP_ENV === 'staging' || APP_ENV === 'localhost'
export const IS_DEBUG = new URLSearchParams(window.location.search).get("contester_debug") === 'true' || IS_STAGING